<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="chemicalForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :is-not-server-handled="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="chemical" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                chemicalForm: () => import('../forms/ChemicalForm'),
                chemical: () => import('../editViews/Chemical'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Chemical Rule', value: 'chemicalRule', format: this.formatEnum },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'chemicals',
                editPageName: 'chemical',
                apiMethod: 'Chemicals',
                claimName: 'Chemicals',
                formTitle: 'Chemical',
                excelTitle: 'Chemicals',
                hasEditPage: true,
            }
        },
    };
</script>
